exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n*::-moz-selection {\n  background: var(--text-highlight-color);\n}\n*::selection {\n  background: var(--text-highlight-color);\n}\n.mp-input-container > .mp-input-field-container > input.mp-input[type=text] {\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 0;\n}\n", ""]);

// exports
